module.exports = __webpack_public_path__ + "static/media/55.f1716d4a.png";